import Decimal from "decimal.js";

function formatNumber(
  value: number | string | Decimal,
  maximumFractionDigits = 2,
  minimumFractionDigits = 0
): string {
  let parsedValue: number;

  if (typeof value == "string") {
    parsedValue = parseFloat(value);
  } else if (value instanceof Decimal) {
    parsedValue = value.toNumber();
  } else {
    parsedValue = value;
  }

  return Intl.NumberFormat("nl-NL", {
    maximumFractionDigits,
    minimumFractionDigits
  }).format(parsedValue);
}

export { formatNumber };
